import { createSlice } from '@reduxjs/toolkit';

const selected_locations = [];
const locationsListModel = [];
const locationsListModelNew = [];
const currentlyExcludedRegions = [];
const currentlyIncludedRegions = [];
const targetingChanges = {
  unsavedData: false,
  validationError: false,
  placement: 'directbuy',
  location: { location: 'all countries', lang: 'all' },
  devices: { brandsModels: 'all', osVersion: 'all' },
  audience: 'TIBA-1449_Control',
};
const getDefaultState = () => {
  return {
    unsavedData: false,
    validationError: false,
    targetingChanges: targetingChanges,
    locationsListModel: locationsListModel,
    locationsListModelNew: locationsListModelNew,
    selected_locations: selected_locations,
    currentlyExcludedRegions: currentlyExcludedRegions,
    currentlyIncludedRegions: currentlyIncludedRegions,
    //excludeRules: { excluded_apps: [], excluded_publishers: [], typeList: [] },
    excludeRules: null,
  };
};
const targetingSlice = createSlice({
  name: 'targetingChanges',
  initialState: getDefaultState(),
  reducers: {
    setDefaultExcludeRules: (state, action) => {
      state.excludeRules = action.payload;
    },
    updateProperty: (state, action) => {
      state.targetingChanges[action.payload.propField] = action.payload.newValue;
      state.unsavedData = true;
    },
    setStartingTargetingLocations: (state, action) => {
      state.selected_locations = action.payload;
      state.locationsList = action.payload;
      state.locationsListModel = action.payload;
      state.locationsListModelNew = action.payload;
      state.unsavedData = false;
    },
    setNewModelTargetingLocations: (state, action) => {
      state.locationsListModelNew = action.payload.newValue;
      state.unsavedData = true;
    },
    updateSelectedLocations: (state, action) => {
      state.selected_locations = action.payload.newValue;
      state.unsavedData = true;
    },
    setNewCampaignLocationsFilters: (state, action) => {
      state.selected_locations = action.payload;
      state.unsavedData = true;
    },
    saveNewLocationFilters: (state, action) => {
      state.selected_locations = action.payload;
      state.unsavedData = true;
    },
    saveCurrentlyExcludedRegions: (state, action) => {
      state.currentlyExcludedRegions = action.payload;
    },
    saveCurrentlyIncludedRegions: (state, action) => {
      state.currentlyIncludedRegions = action.payload;
    },
  },
});

export const targetingActions = targetingSlice.actions;
export default targetingSlice.reducer;
